<section class="block default-padding margin--bottom-l margin--top-l">
  <div class="default-max-width centered">
    <div class="layout-hero-tiles">
      <div class="layout-hero-tiles-lower">
        <div class="layout-hero-tiles-item layout-hero-tiles-lower-left">
          <div
            *ngIf="data.teaser[0]?.teaser?.image?.formats?.large?.url || data.teaser[0]?.teaser?.image?.url"
            class="bg-image-tile"
            [ngStyle]="{
              'background-image': 'url(' + (data.teaser[0]?.teaser?.image?.formats?.large?.url || data.teaser[0]?.teaser?.image?.url) + ')'
            }"
          >
            <div class="bg-image-tile-main bg-image-tile-push">
              <p class="headline-third"></p>
              <p class="bg-image-tile-title headline-second">
                {{ data.teaser[0].teaser.title }}
              </p>

              <a
                *ngIf="data.teaser[0].teaser.button"
                [href]="data.teaser[0].teaser.link"
                class="bg-image-tile-button btn btn--small btn--bright"
                >{{ data.teaser[0].teaser.button }}</a
              >
            </div>
          </div>
        </div>
        <div class="layout-hero-tiles-lower-right">
          <div class="layout-hero-tiles-lower-right-top layout-hero-tiles-item">
            <div
              *ngIf="data.teaser[1]?.teaser?.image?.formats?.large?.url || data.teaser[1]?.teaser?.image?.url"
              class="bg-image-tile bg-image-tile--medium-height"
              [ngStyle]="{
                'background-image':
                  'url(' + (data.teaser[1]?.teaser?.image?.formats?.large?.url || data.teaser[1]?.teaser?.image?.url) + ')'
              }"
            >
              <div class="bg-image-tile-main bg-image-tile-push">
                <p class="headline-third"></p>
                <p class="bg-image-tile-title headline-second">
                  {{ data.teaser[1].teaser.title }}
                </p>

                <a
                  *ngIf="data.teaser[1].teaser.button"
                  [href]="data.teaser[1].teaser.link"
                  class="bg-image-tile-button btn btn--small btn--bright"
                  >{{ data.teaser[1].teaser.button }}</a
                >
              </div>
            </div>
          </div>
          <div class="layout-hero-tiles-lower-right-bottom layout-hero-tiles-item">
            <div
              *ngIf="data.teaser[2]?.teaser?.image?.formats?.large?.url || data.teaser[2]?.teaser?.image?.url"
              class="bg-image-tile bg-image-tile--small-height"
              [ngStyle]="{
                'background-image':
                  'url(' + (data.teaser[2]?.teaser?.image?.formats?.large?.url || data.teaser[2]?.teaser?.image?.url) + ')'
              }"
            >
              <div class="bg-image-tile-main bg-image-tile-push">
                <p class="headline-third"></p>
                <p class="bg-image-tile-title headline-second">
                  {{ data.teaser[2].teaser.title }}
                </p>

                <a
                  *ngIf="data.teaser[2].teaser.button"
                  [href]="data.teaser[2].teaser.link"
                  class="bg-image-tile-button btn btn--small btn--bright"
                  >{{ data.teaser[2].teaser.button }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
